import { render } from "./RootElement.vue?vue&type=template&id=7c24e2a9&ts=true&lang=pug"
import script from "./RootElement.vue?vue&type=script&setup=true&lang=ts"
export * from "./RootElement.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__